
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { type WideCardType, NewCoursePopOption } from '@xt/client/types/home.d'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import NewCoursePop from './newCoursePop/index.vue'
import HeadCard from './card/headCard.vue'
import WideCard from './card/wideCard.vue'
import lodash from 'lodash'

@Component({
  components: {
    WideCard,
    HeadCard,
    NewSwiper,
    NewCoursePop
  }
})
export default class extends Vue {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  @Ref()
  newCoursePop: {
    open: (option: NewCoursePopOption) => void
    hide: () => void
  }

  activeIndex: number = 0

  get dataSource() {
    return this.$store.$homeV2.dataSource?.registrationRecommend
  }

  get dataList(): WideCardType[][] {
    return lodash.chunk(this.dataSource?.list, 4)
  }

  handleOpenNewCoursePop(data: NewCoursePopOption) {
    this.newCoursePop.open(data)
  }

  handleChange(index) {
    this.activeIndex = index
  }

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
